<template>
	<div class="mb-3">
		<span class="text-secondary d-block fs-6 w-100">{{ label }}</span>
		<span class="text-primary d-block fs-5 fs-md-4 w-100 text-break position-relative text-block-value">
			<slot />
			<i v-if="!hasContent" class="text-secondary">N/A</i>
			<button
				v-if="copyable && hasContent"
				class="btn btn-link btn-sm text-secondary p-0 ms-1 text-block-copy-btn"
				:title="copied ? 'Copied!' : 'Copy'"
				@click="copyText"
			>
				<i :class="copied ? 'bi bi-check-lg text-success' : 'bi bi-copy'"></i>
			</button>
		</span>
	</div>
</template>

<script lang="ts">
import { Component, Prop, toNative, Vue } from 'vue-facing-decorator'

@Component({})
class TextBlock extends Vue {
	@Prop({ type: String })
	readonly label!: string

	@Prop({ type: Boolean, default: false })
	readonly copyable!: boolean

	copied = false
	copyTimeout: ReturnType<typeof setTimeout> | null = null

	get slotText(): string {
		const slot = this.$slots.default?.()
		if (!slot) return ''
		return slot
			.map((vnode) => {
				if (typeof vnode.children === 'string') return vnode.children
				if (Array.isArray(vnode.children)) {
					return vnode.children
						.map((child) => (typeof child === 'object' && child && 'children' in child ? child.children : child))
						.join('')
				}
				return ''
			})
			.join('')
			.trim()
	}

	get hasContent(): boolean {
		return this.slotText.length > 0
	}

	copyText() {
		const text = this.slotText
		if (!text) return

		navigator.clipboard.writeText(text).then(() => {
			this.copied = true
			if (this.copyTimeout) clearTimeout(this.copyTimeout)
			this.copyTimeout = setTimeout(() => {
				this.copied = false
			}, 2000)
		})
	}
}
export default toNative(TextBlock)
</script>

<style scoped>
.text-block-copy-btn {
	opacity: 0;
	transition: opacity 0.15s ease;
	vertical-align: middle;
	line-height: 1;
}
.text-block-value:hover .text-block-copy-btn {
	opacity: 1;
}
</style>